import { Fragment, useContext, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  ExclamationTriangleIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";
import { getAuth } from "firebase/auth";
import { UserContext } from "../../context/user-context";
import { useNavigate } from "react-router";
import { UserDetailsContext } from "../../context/user-details";

function Modal({
  message,
  open,
  setOpen,
  error,
  buttonMessage,
  confirm,
  isEdit,
  setIsEdit,
}) {
  const cancelButtonRef = useRef(null);
  const closeEdit = () => {
    setIsEdit(false);
    setOpen(false);
  };

  const actionClick = () => {
    setOpen(false);
  };

  const { setCurrentUser, setDatabaseUser } = useContext(UserContext);
  const { setDetails } = useContext(UserDetailsContext);
  const navigate = useNavigate();

  const signOutHandler = async () => {
    await getAuth().signOut();
    setOpen(false);
    setDatabaseUser(null);
    setCurrentUser(null);
    setDetails(null);

    navigate("/login");
  };
  const viewPost = () => {
    navigate("/Jobs");
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10 "
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto  ">
          <div className="flex min-h-full   justify-center p-4 text-center items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full max-sm:w-4/6 sm:max-w-lg">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div
                      className={`   ${
                        error === "error" ? "bg-red-100" : "bg-green-100"
                      }  first-line:mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full  sm:mx-0 sm:h-10 sm:w-10`}
                    >
                      {error === "error" ? (
                        <ExclamationTriangleIcon
                          className="h-6 w-6 text-red-600"
                          aria-hidden="true"
                        />
                      ) : (
                        <CheckCircleIcon
                          className="h-6 w-6 text-[#4BB543]"
                          aria-hidden="true"
                        />
                      )}
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900"
                      >
                        {error === "error" ? "Alert" : "Success"}
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-700">{message}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className={` ${
                      error === "error"
                        ? "bg-red-600 hover:bg-red-500"
                        : "bg-green-600 hover:bg-green-500"
                    }  inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
                    onClick={
                      confirm === "signout"
                        ? signOutHandler
                        : confirm === "post"
                        ? viewPost
                        : isEdit
                        ? closeEdit
                        : actionClick
                    }
                  >
                    {buttonMessage}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => {
                      setOpen(false);
                      confirm === "post" && navigate("/");
                    }}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
export default Modal;
